import axios from '../api/axios';

const QuotationService = {
    getList: async (params) => {
        const response = await axios.get('/Quotation', { params });
        return response.data;
    },
    get: async (id) => {
        const response = await axios.get(`/Quotation/${id}`);
        return response.data;
    },
    create: async (data) => {
        const response = await axios.post('/Quotation', data);
        return response.data;
    },
    update: async (data) => {
        const response = await axios.put('/Quotation', data);
        return response.data;
    },
    updateStatus: async (id, status) => {
        const response = await axios.put(`/Quotation/${id}/status`, status, {
            headers: { 'Content-Type': 'application/json' }
        });
        return response.data;
    },
    convertToSale: async (id) => {
        const response = await axios.post(`/Quotation/${id}/convert-to-sale`);
        return response.data;
    }
};

export default QuotationService;
